import React from "react";

const StatusCard = ({ title, value }) => {
  return (
    <div className="bg-[#0e0e0e] flex flex-row justify-between items-center rounded-xl border-[0.8px] border-[#434343] px-4 py-3 w-full">
      <p className="text-[11px]">{title}</p>
      <h1 className="text-[13px] font-bold text-[#200052]">{value}</h1>
    </div>
  );
};

export default StatusCard;
